import { useMemo } from 'react'
import { captureException } from '@sentry/react'
import { useNavigate, useSearch } from '@tanstack/react-router'

import { useAppNavbar } from '@/shared/hooks/use-app-navbar'
import { dismissApp } from '@/shared/lib/app-bridge'
import { Button, Icon } from '@/shared/ui'

import styles from './pass-card-bind-error.module.scss'

export const PassCardBindError = () => {
    useAppNavbar(' ', null, null)
    const navigate = useNavigate()

    const { error } = useSearch({ from: '/_protected/pass-card-bind/error' })

    captureException(new Error(`error: ${error}`), {
        tags: {
            errorType: 'pass-card-bind',
        },
    })

    const errorTitle = useMemo(() => {
        if (error === 'card_not_found') {
            return 'Не удалось добавить карту'
        }
        if (error === 'max payment methods reached') {
            return 'Превышено количество способов оплаты'
        }

        return 'Ошибка загрузки'
    }, [error])

    const errorDescription = useMemo(() => {
        if (error === 'card_not_found') {
            return (
                <>
                    Попробуйте добавить другую карту или
                    <br />
                    выберите другой способ оплаты
                </>
            )
        }
        if (error === 'max payment methods reached') {
            return <>Превышено количество способов оплаты</>
        }

        return (
            <>
                Попробуйте еще раз или напишите
                <br /> в поддержку
            </>
        )
    }, [error])

    const errorButtons = useMemo(() => {
        if (error === 'card_not_found') {
            return (
                <div className={styles['pass-card-bind-error__buttons']}>
                    <Button
                        size='large'
                        variant='secondary'
                        onClick={() => {
                            navigate({ to: '..', replace: true })
                        }}
                    >
                        Добавить другую карту
                    </Button>

                    <Button
                        size='large'
                        variant='primary'
                        onClick={() => {
                            dismissApp()
                        }}
                    >
                        Сменить способ оплаты
                    </Button>
                </div>
            )
        }

        return (
            <div className={styles['pass-card-bind-error__buttons']}>
                <Button
                    size='large'
                    variant='primary'
                    onClick={() => {
                        dismissApp()
                    }}
                >
                    Повторить
                </Button>
            </div>
        )
    }, [error, navigate])

    return (
        <div className={styles['pass-card-bind-error']}>
            <div className={styles['pass-card-bind-error-content']}>
                <div className={styles['pass-card-bind-error-content__icon']}>
                    <Icon
                        color='var(--extensions-text-and-icon-warning)'
                        icon='warning'
                        size={40}
                    />
                </div>
                <span className={styles['pass-card-bind-error-content__title']}>{errorTitle}</span>
                <span className={styles['pass-card-bind-error-content__description']}>
                    {errorDescription}
                </span>
            </div>
            {errorButtons}
        </div>
    )
}
